import type { Facet, FacetOption } from '../types/Facet';

export const markActiveFacetOptions = (
  facets: Facet[],
  activeFacetValuesByKey: Record<string, string[]>,
): Facet[] =>
  facets.map((facet) => {
    const activeValues = activeFacetValuesByKey[facet.alias] ?? [];
    const activeSet = new Set(activeValues);
    const knownValues = new Set(facet.options.map((option) => option.value));

    const updatedOptions: FacetOption[] = facet.options.map((option) => ({
      ...option,
      active: activeSet.has(option.value),
    }));

    activeValues.forEach((value) => {
      if (!knownValues.has(value)) {
        updatedOptions.push({ active: true, count: null, title: value, value });
      }
    });

    return { ...facet, options: updatedOptions };
  });
